import type { AttentionCardMessageCaseModel } from '@components/attention_card/_attention_card.controller';
import { CaseCard } from '@components/case_card.component';
import { Icon } from '@components/icon.component';
import { withTranslation } from '@modules/i18n_and_l10n/with_translation';
import { DateService } from '@services/date.service';
import { useService } from '@visiba/instantiation';
import { AttentionCardCaseCardWrapper } from './_attention_card_case_card_wrapper.component';

interface Props {
	description: string;
	message: AttentionCardMessageCaseModel;
	analyticAction: string;
}

export function AttentionCardCaseCardMessage({ message, description, analyticAction }: Props): JSX.Element {
	const dateService = useService(DateService);

	let date: string;
	if (dateService.isToday(message.dateInstance)) {
		date = withTranslation('Common.Word.Today');
	} else if (dateService.isYesterday(message.dateInstance)) {
		date = withTranslation('Common.Word.Yesterday');
	} else {
		date = message.dateFormatted;
	}

	return (
		<AttentionCardCaseCardWrapper
			description={description}
			to={message.link}
			analyticAction={analyticAction}
			ariaLabel={withTranslation('PW.Component.AttentionCard.Message.Aria')}
		>
			<CaseCard>
				<CaseCard.Thumbnail size={24} type='themed'>
					<Icon type='messaging' />
				</CaseCard.Thumbnail>
				<CaseCard.Title>
					{message.unreadCount > 1
						? withTranslation('PW.Component.AttentionCard.Message.SubjectPlural', { count: message.unreadCount.toString() })
						: withTranslation('PW.Component.AttentionCard.Message.Subject', { count: message.unreadCount.toString() })}
				</CaseCard.Title>
				<CaseCard.Date>{date}</CaseCard.Date>
				<CaseCard.Icon>
					<Icon type='attentionCardArrow' />
				</CaseCard.Icon>
			</CaseCard>
		</AttentionCardCaseCardWrapper>
	);
}
